module.exports = __webpack_public_path__ + "static/img/icon5.7e0c88f7.svg";